/**
 * G10 — quarantine corrupt multi-cart registry when render storm is detected.
 */

import { rebuildCartRegistryFromStorage } from '../../features/shop/cart/cartRegistry.js';
import {
  CART_REGISTRY_STORAGE_KEY,
  isCartRegistryRawCorrupt,
  readRawCartRegistry,
  writeCartRegistry,
} from '../../features/shop/cart/cartRegistryStorage.js';
import { readPersistedCartQuantity } from '../../features/shop/cart/cartPersistenceRead.js';

let quarantineRanThisSession = false;

/**
 * Best-effort heal: drop corrupt registry JSON or rebuild from cart payloads.
 * Idempotent per session unless `force` is true.
 */
export function quarantineCartRegistryOnRenderStorm(force = false): boolean {
  if (quarantineRanThisSession && !force) {
    return false;
  }
  if (typeof window === 'undefined' || window.localStorage === undefined) {
    return false;
  }

  const raw = window.localStorage.getItem(CART_REGISTRY_STORAGE_KEY);
  const corrupt = isCartRegistryRawCorrupt(raw);
  if (corrupt) {
    window.localStorage.removeItem(CART_REGISTRY_STORAGE_KEY);
  }

  rebuildCartRegistryFromStorage(readPersistedCartQuantity);

  const rebuilt = readRawCartRegistry();
  writeCartRegistry(rebuilt.entries);

  quarantineRanThisSession = true;
  return corrupt || raw !== null;
}

export function resetCartRegistryStormRecoveryForTests(): void {
  quarantineRanThisSession = false;
}
